// src/components/TermsOfService.js
import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Terms of Service</h1>
      <p>
        Welcome to <strong>E-comm</strong>. By accessing or using our website, you agree to be bound by the following terms and conditions.
      </p>

      <h3>1. Use of Website</h3>
      <p>
        You agree to use our platform only for lawful purposes. Any misuse or unauthorized access is strictly prohibited.
      </p>

      <h3>2. Account Responsibility</h3>
      <p>
        You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities under your account.
      </p>

      <h3>3. Product Information</h3>
      <p>
        We strive to ensure that all product information is accurate. However, we do not guarantee that all product descriptions or other content is error-free.
      </p>

      <h3>4. Pricing & Payment</h3>
      <p>
        All prices are listed in INR and are subject to change without notice. We reserve the right to refuse or cancel any order at our sole discretion.
      </p>

      <h3>5. Intellectual Property</h3>
      <p>
        All content on this website (text, images, logos, etc.) is the property of E-comm and is protected by copyright laws.
      </p>

      <h3>6. Limitation of Liability</h3>
      <p>
        E-comm shall not be held liable for any indirect or consequential damages arising from the use of our platform.
      </p>

      <h3>7. Changes to Terms</h3>
      <p>
        We may update these terms from time to time. Continued use of the site means you accept any changes.
      </p>

      <p>
        If you have any questions about our terms, contact us at <strong>legal@ecomm.com</strong>.
      </p>
    </div>
  );
};

export default TermsOfService;
